/**
 * Return true if the polyfill is required, otherwise false.
 *
 * The polyfill is required, if the {@link requestSubmit} function doesn't exist on prototype {@link HTMLFormElement}.
 */
const isRequired = () => typeof HTMLFormElement.prototype.requestSubmit !== "function";

/**
 * Install the polyfill if it is required.
 *
 * @return true if the polyfill was installed otherwise false.
 */
const install = async () => {
    if (!isRequired()) {
        return false;
    }
    (await import('../common/initialize-36291998.js')).initialize();
    return true;
};

export default install;
